export const SITE = {
  name: "SkyRise Estate & Construction",
  legalName: "SKYRISE ESTATE & CONSTRUCTION PVT. LTD",
  short: "SkyRise",
  tagline: "Building Trust, Rising Higher",
  taglineSub: "Vastu-planned homes. Vastu-aligned lives.",
  cin: "U41001WB2026PTC294963",
  regNo: "294963",
  domain: "skyriseestate.in",
  phone: "8777 698 228",
  phone2: "8910 953 800",
  phoneDigits: "918777698228",
  phone2Digits: "918910953800",
  telHref: "tel:+918777698228",
  tel2Href: "tel:+918910953800",
  whatsappHref: "https://wa.me/918777698228?text=Hello%20SkyRise%2C%20I%20am%20interested%20in%20your%20Vastu-planned%20projects.",
  siteVisitHref: (project) => `https://wa.me/918777698228?text=${encodeURIComponent(`Hi, I would like to know more about "${project} service". Please share more details`)}`,
  email: "skyrise.headoffice@gmail.com",
  address: "Bally SkyHigh, Flat No 2/1B, Amtala Bus Stop, PO — Samabaya Pally, PS — Nischinda, Bally, Dist — Howrah, West Bengal 711205",
  addressShort: "Bally SkyHigh · Bally · Howrah · WB 711205",
  city: "Bally, Howrah, West Bengal",
  mapEmbed: "https://www.google.com/maps?q=22.655,88.329&hl=en&z=17&output=embed",
  mapLink: "https://maps.google.com/?q=Bally+SkyHigh,+Amtala+Bus+Stop,+Bally,+Howrah,+West+Bengal+711205",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_c2e6edea-21c7-4b67-af71-bba15ceb30b7/artifacts/69xoco0c_LOGO.png",
};

export const PROMOTER = {
  photo: "/images/promoter.jpeg",
  role: "Founder & Managing Director",
  quote: "Every square foot we build — every wall we raise, every road we lay, every interior we finish — is aligned with Vastu Shastra. Because a home is not just walls and beams; it is where a family's energy grows. That belief is the foundation of SkyRise.",
  credentials: [
    "Certified by Skill India & NITI Aayog",
    "ICL-certified Vastu construction practice",
    "Trained Vastu consultant & PMKVY empanelled",
  ],
};

export const HERO_IMAGES = [
  "/images/home.jpeg",
  "/images/home.jpeg",
];

export const PROJECTS = [
  { title: "Floor Elevation", category: "Residential", location: "Bela Nagar, Bally, Howrah", img: "/images/home.jpeg" },
  //{ title: "SkyHigh Grand Elevation", category: "Residential", location: "Patia, Bhubaneswar", img: "/images/project-2.jpeg" },
  { title: "Grand Entrance", category: "Infrastructure", location: "Benz Circle, Vijayawada", img: "/images/grand-ent.jpeg" },
  { title: "TV Wall Cabinet", category: "Interior Design", location: "Doranda, Howrah", img: "/images/interior-tv-wall.jpeg" },
  { title: "Living Room — Ceiling Design", category: "Interior Design", location: "Jayadev Vihar, Bhubaneswar", img: "/images/interior-livingroom.jpeg" },
  { title: "Modular Kitchen", category: "Interior Design", location: "MG Road, Vijayawada", img: "/images/interior-kitchen.jpeg" },
  { title: "Premium Residence", category: "Residential", location: "Governorpet, Vijayawada", img: "/images/residential_building.jpeg" },
  { title: "Executive Office Suite", category: "Interior Design", location: "Bhubaneswar", img: "/images/exec-office.jpeg" },
  { title: "Reception & Guest Lounge", category: "Interior Design", location: "Howrah", img: "/images/rec-lounge.jpeg" },
];

export const SERVICES = [
  {
    id: "road",
    icon: "TrafficCone",
    title: "Road Construction",
    short: "Roads, driveways, internal-society roads and civil infrastructure — planned in accordance with Vastu direction principles.",
    description: "From colony access roads to society driveways and civil paving works — we handle survey, excavation, sub-grade, sub-base, bituminous & concrete surfacing with strict quality control. Approach roads, gate placement and drainage are all planned as per Vastu Shastra for positive prana flow.",
    points: [
      "Access Roads,Society Internal Roads & Driveways",
      "Concrete & Bituminous Paving",
      "Storm-water Drainage & Culverts",
    ],
    img: "/images/road-construction.jpeg",
  },
  {
    id: "building",
    icon: "Building2",
    title: "Building Construction (as per Vastu)",
    short: "Commercial buildings, residential houses & multi-storey towers — every wall, opening and elevation planned as per Vastu.",
    description: "SkyRise builds every building type in strict accordance with Vastu Shastra — from a single-family home to multi-storey apartment towers and commercial complexes. Plot orientation, main entrance direction, kitchen Agni corner, master bedroom in the earth quadrant, staircase placement, water sources and even structural column grids are all locked as per Vastu before RCC begins. Nothing is ornamental. Everything is intentional.",
    points: [
      "Vastu Site Planning & Orientation",
      "Commercial Buildings & Retail Complexes",
      "Residential Houses (single-family)",
      "Multi-storey Residential Towers",
    ],
    img: "/images/building-construction.jpeg",
  },
  {
    id: "interior",
    icon: "Sofa",
    title: "Interior Design",
    short: "Interior decoration, space planning, modular furniture and turnkey fit-outs — as per modern designs.",
    description: "We plan and execute interiors in strict alignment with Vastu principles — direction, energy flow, colour and material — combined with modern space planning, modular furniture, false ceiling, lighting and joinery. Peace at home, prosperity at work.",
    points: [
      "Vastu-aligned Space Planning",
      "Modular Furniture & Joinery",
      "False Ceiling, Lighting & Finishes",
      "Turnkey Residential & Office Fit-outs",
    ],
    img: "/images/interior-livingroom.jpeg",
  },
  {
    id: "realestate",
    icon: "MapPinned",
    title: "Real Estate — Plot & Flat Sales",
    short: "Plot selling and selling of commercial & residential flats and land — all vetted before we list them.",
    description: "We deal in plots, buildings, apartments, flats, commercial spaces and land parcels — every listing is vastu-vetted for orientation and prana flow before we present it to a buyer. Clear title verification, transparent documentation and end-to-end registration support.",
    points: [
      "Vastu-Vetted Plot Selling",
      "Residential Flat & Apartment Sales",
      "Commercial Space Sales & Leasing",
      "Land Sales — Freehold & Leasehold",
    ],
    img: "/images/plot-flat.jpeg",
  },
  {
    id: "materials",
    icon: "Truck",
    title: "Building Materials Sales",
    short: "Cement, steel, bricks, aggregates, tiles, paints, sanitary ware, electricals & construction equipment.",
    description: "A dependable supply-chain partner for construction, infrastructure and interior works — competitively priced, reliably delivered across our operating cities, with full transparency on brand, grade and MRP.",
    points: [
      "Cement, Steel, Bricks & Aggregates",
      "Tiles, Paints & Sanitary Ware",
      "Electricals & Interior Products",
      "Construction Equipment & Tools",
    ],
    img: "/images/building-mat-sales.jpeg",
  },
];

export const STATS = [
  { value: "9", label: "Projects Delivered" },
  { value: "100+", label: "Satisfied Families" },
  { value: "5", label: "Years Experience" },
  { value: "3", label: "Cities Served" },
];

export const TESTIMONIALS = [
  {
    quote: "SkyRise built our home strictly as per Vastu — every corner, every direction, every finish. Six months in, we can feel the harmony in the space.",
    name: "A. Sen",
    role: "Homeowner, Howrah",
  },
  {
    quote: "Their cozy interior design brought a real sense of calm to our new home. Attention to material and craftsmanship was exceptional.",
    name: "P. Ghosh",
    role: "Residential Client, Howrah",
  },
  {
    quote: "Reliable materials supply, transparent pricing and on-time dispatch — SkyRise has become our default vendor across sites.",
    name: "R. Das",
    role: "Contractor, Howrah",
  },
];

export const WHY_US = [
  { title: "Vastu-First Construction", body: "Every SkyRise home, office, road and interior is oriented, planned and finished in strict accordance with Vastu Shastra — direction, energy, colour and material flow." },
  { title: "Stability & Prosperity", body: "Deep-blue reliability meets gold-standard craftsmanship in every square foot we build and every property we transact." },
  { title: "End-to-End Capability", body: "One partner across road & building construction, Modern interiors, real estate and materials — no vendor coordination headaches." },
  { title: "Double Leadership", body: "Two energies — the SkyRise ethos of stability and decades of on-ground flawless execution — combined into one accountable delivery team." },
];
